// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging"; // Bu satır zaten vardı
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCX8JXpIEswyap1woTkfIOddscGef59j6w",
  authDomain: "randevupp-ahmettosun.firebaseapp.com",
  projectId: "randevupp-ahmettosun",
  storageBucket: "randevupp-ahmettosun.firebasestorage.app",
  messagingSenderId: "733872211570",
  appId: "1:733872211570:web:d27dae94247ea64ec224eb",
  measurementId: "G-JZYR3P39N9",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig); //
const analytics = getAnalytics(app); //

// --- EKSİK KISIM BURASIYDI ---
// Messaging servisini başlat ve export et
export const messaging = getMessaging(app);
// --- DÜZELTME SONU ---

// app'i de default olarak export edebilirsiniz (opsiyonel)
export default app;
